import { render, staticRenderFns } from "./ReqAddRemTrend.vue?vue&type=template&id=701a6e60&scoped=true"
import script from "./ReqAddRemTrend.vue?vue&type=script&lang=js"
export * from "./ReqAddRemTrend.vue?vue&type=script&lang=js"
import style0 from "./ReqAddRemTrend.vue?vue&type=style&index=0&id=701a6e60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701a6e60",
  null
  
)

export default component.exports